import { useMemo } from 'react';
import { mediaManagerImageEditToolClick } from '@wix/bi-logger-media-manager-g6/v2';
import { bi } from '../../../services/loggers/bi';
import { getItemFormat } from '../../bi';

export enum ImageEditToolTarget {
  CropAndRotate = 'crop',
  Adjust = 'adjust',
  ChangeBackground = 'background',
  AdobeExpress = 'adobe',
}

export enum ImageEditToolClickOrigin {
  ActionBar = 'top_panel',
  InfoPanel = 'more_info',
  Preview = 'preview_in_info_panel',
  ImageThumbnails = 'image_thumbnails',
}

export const useTrackImageEditToolClick = () =>
  useMemo(
    () => ({
      trackImageEditToolClick: (target, clickOrigin, file) =>
        bi.logger().report(
          mediaManagerImageEditToolClick({
            fileFormat: getItemFormat(file),
            fileId: file.id,
            target,
            clickOrigin,
          }),
        ),
    }),
    [],
  );
